'use client'

import { LangCode } from '@/components/i18n/lang-context'
import { Partner } from '@/types/partner'
import { LBCarrousel } from './lb-carrousel'

export function LBPartners({langCode, partners, partner, noTitle=false}: {langCode: LangCode, partners: Partner[], partner: Partner|undefined, noTitle?: boolean}) {

  return <LBCarrousel langCode={langCode} items={partners} partner={partner} noTitle={noTitle}/>
}
